var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex relative",
    on: {
      "focusin": function ($event) {
        _vm.focus = true;
      },
      "focusout": _vm.onFocusOut
    }
  }, [!_vm.hideContacts ? [_vm.showContacts ? [_vm.isSignedIn ? _c('contacts-dialog', {
    attrs: {
      "single": ""
    },
    on: {
      "select": function (v) {
        _vm.staged = _vm.$options.filters['email-phone'](v);
        _vm.showContacts = false;
      },
      "close": function ($event) {
        _vm.showContacts = false;
      }
    }
  }) : _c('sign-in-dialog', {
    attrs: {
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.$nextTick(function () {
          return _vm.showContacts = !!_vm.isSignedIn;
        });
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("Ellacard contacts")];
      },
      proxy: true
    }, {
      key: "subtitle",
      fn: function () {
        return [_vm._v("Sign in to access / import your contacts")];
      },
      proxy: true
    }], null, false, 1299667221)
  })] : _vm._e(), _c('div', {
    staticClass: "flex-shrink-0 btn-container",
    class: {
      fixed: _vm.fixed,
      focus: _vm.focus
    }
  }, [_c('v-btn', {
    staticClass: "btn-tooltip left persistent px-2",
    attrs: {
      "hover": "",
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        _vm.showContacts = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCardAccountPhone)
    }
  })], 1)], 1)] : _vm._e(), _c('v-text-field', {
    ref: "input",
    staticClass: "white inline-error",
    attrs: {
      "type": "text",
      "outlined": "",
      "flat": "",
      "dense": "",
      "placeholder": "Email address / phone number",
      "autocomplete": "do-not-autocomplete",
      "hint": _vm.hint,
      "persistent-hint": !!_vm.hint,
      "label": _vm.label,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "rules": [function (v) {
        return !_vm.e164 || _vm.e164.startsWith('+1') || 'US / CA phone numbers only';
      }, function (v) {
        return !_vm.required || !!_vm.target;
      }, function (v) {
        return !_vm.counts || (_vm.counts[_vm.e164 || _vm.staged.toLowerCase()] || 0) <= 1 || 'Duplicate';
      }].concat(_vm.rules),
      "append-icon": _vm.isValidEmail && _vm.mdiAt || _vm.isValidPhone && _vm.mdiMessage || null
    },
    on: {
      "paste": _vm.onPaste,
      "focus": function (e) {
        return _vm.$emit('focus', e);
      },
      "blur": function (e) {
        if (_vm.isValidPhone) _vm.staged = _vm.$options.filters['email-phone'](_vm.e164);
        _vm.$emit('blur', e);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return function (e) {
          return _vm.$emit('enter', e);
        }.apply(null, arguments);
      }
    },
    model: {
      value: _vm.staged,
      callback: function ($$v) {
        _vm.staged = $$v;
      },
      expression: "staged"
    }
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }